import { render, staticRenderFns } from "./newMenu.vue?vue&type=template&id=1a875664&"
import script from "./newMenu.vue?vue&type=script&lang=js&"
export * from "./newMenu.vue?vue&type=script&lang=js&"
import style0 from "./newMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports